import GenericChannel from './genericChannel.react';
import GenericChannelOptionEdit from './genericChannelOptionEdit.react';
import companySearchView from './virtualChannels/companySearchView.react';
import companySearchChannelOptionEdit from './virtualChannels/companySearchOptionEdit.react';
import RossumChannelView from './virtualChannels/rossumChannelView.react';
import AgentChannelEdit from './virtualChannels/agentChannelEdit.react';

let channelTypeMap = {
    "com.dativery.company": {
        view: companySearchView,
        options: companySearchChannelOptionEdit
    },
    "ai.rossum.elis": {
        view: RossumChannelView,
    },
    "cz.pohoda": {
        options: AgentChannelEdit
    }
};

export function getChannelView(type) {
    if (type in channelTypeMap && channelTypeMap[type].view) {
        return channelTypeMap[type].view;
    }

    return GenericChannel;
}

export function getChannelOptions({type, requiresAgent}) {
    if (type in channelTypeMap && channelTypeMap[type].options) {
        return channelTypeMap[type].options;
    }

    if (requiresAgent) {
        return AgentChannelEdit;
    }

    return GenericChannelOptionEdit;
}
